import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { urlSearchParamsToObj } from 'Utils/routerUtils'

// import css from './styles.js'
import { _Pagination, _PaginationItem } from './styles'


// eslint-disable-next-line
const renderPaginationItem = ({ currentPageNum, isCurrent = false, pathname, hash, searchQuery, offer, onPaginationClick }) => (
  <_PaginationItem
    isActive={isCurrent}
    key={currentPageNum}
  >
    <Link
      data-test-id="paginationItem"
      to={{ pathname, hash, search: new URLSearchParams(searchQuery).toString() }}
      onClick={() => { onPaginationClick(currentPageNum, offer) }}
    >
      {currentPageNum}
    </Link>
  </_PaginationItem>
)

const Pagination = ({ location, totalCount, currentPage = 1,
  perPage = 1, offer, onPaginationClick }) => {
  const { pathname, search, hash } = location
  const range = []
  const collapse = 5
  const totalPages = Math.ceil(totalCount / perPage)


  const searchQuery = search ? urlSearchParamsToObj(search) : {}
  let lastDot = false
  for(let i = 0; i < totalPages; ++i) { range.push(i) } // eslint-disable-line
  return (
    <_Pagination>
      {
        range.map((num) => {
          const currentPageNum = num + 1
          searchQuery.page = currentPageNum

          const isCurrent = currentPageNum === currentPage
          const propsPage = currentPage
          /* eslint-disable */
          if(
            totalPages <= collapse + 1 || totalPages === currentPageNum || currentPageNum === 1 ||
            (propsPage < collapse && currentPageNum <= collapse) ||
            (propsPage > totalPages - collapse + 1 && currentPageNum >= totalPages - collapse + 1) ||
            (propsPage >= collapse && propsPage <= totalPages - collapse + 1 && Math.abs(currentPageNum - propsPage) < 2)
          ) {
            lastDot = false

            return renderPaginationItem({ currentPageNum, isCurrent, pathname, hash, searchQuery, offer, onPaginationClick })
          } else if(lastDot) {
            return ''
          }
          /* eslint-enable */
          lastDot = true
          return <_PaginationItem key={currentPageNum}><span>...</span></_PaginationItem>
          //
        })
      }
    </_Pagination>
  )
}

Pagination.propTypes = {
  perPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,

  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    hash: PropTypes.string,
  }).isRequired,
  offer: PropTypes.string,
  onPaginationClick: PropTypes.func,
}

export default Pagination
